module.exports = __webpack_public_path__ + "assets/img/logo_header.59910432.png";